import useResource from "../../../hooks/UseResource";
import * as InjuryLocationService from "../../../services/InjuryLocationService";

export default function useInjuryLocation(id) {
    return useResource(id, InjuryLocationService.findInjuryLocationById);
}
